import { BrowserRouter, Routes, Route } from "react-router-dom";
import MaterialTalk from "./material-talk";
import About from "./pages/About";
import Podcast from "./pages/Podcast";
import Articles from "./pages/Articles";
import People from "./pages/People";
import Contact from "./pages/Contact";
import ArticlePage from "./pages/ArticlePage";
import { Analytics } from "@vercel/analytics/react";
import Fashboard from "./pages/Fashboard";

export default function App() {
  return (
    <BrowserRouter>
      <Analytics />
        <Routes>
          <Route path="/" element={<MaterialTalk />} />
          <Route path="/about" element={<About />} />
          <Route path="/podcast" element={<Podcast />} />
          <Route path="/articles" element={<Articles />} />
          <Route path="/people" element={<People />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/articles/:slug" element={<ArticlePage />} />
          <Route path="/fashboard" element={<Fashboard />} />
        </Routes>
    </BrowserRouter>
  );
}